import { ADD_SUCCESS, CLEAR_SUCCESSES, REMOVE_SUCCESS } from '../actions/SuccessActions';

export default (state = [], action) => {
  switch (action.type) {
    case ADD_SUCCESS: {
      const success = {
        code: action.code,
        message: action.message,
      };
      return [...state.filter((s) => s.message !== success.message), success];
    }
    case REMOVE_SUCCESS:
      return state.filter((success) => success !== action.success);
    case CLEAR_SUCCESSES:
      return [];
    default:
      return state;
  }
};
